<template>
  <CCard class="employee-table-card shadow-sm border-0">
    <CCardHeader class="employee-table-header">
      <slot name="header">
        <CIcon name="cil-grid"/> {{caption}}
      </slot>
    </CCardHeader>
    <CCardBody class="employee-table-body">
      <CDataTable
        :hover="hover"
        :striped="striped"
        :border="border"
        :small="small"
        :fixed="fixed"
        :items="items"
        :fields="fields"
        :items-per-page="small ? 20 : 8"
        :dark="dark"
        pagination
      >
        <template #status="{item}">
          <td>
            <CBadge :color="getBadge(item.status)">{{item.status}}</CBadge>
          </td>
        </template>
        <template #action="{item}">
          <td class="text-center text-nowrap">
            <router-link
              :to="{
                name: 'individualDTR',
                params: { pID: item.BiometricID },
                query: dtrQuery,
              }"
              class="mr-2"
              title="View DTR"
            >
              <i class="bi bi-eye-fill"></i>
            </router-link>
            <router-link
              :to="{
                name: 'individualDTR',
                params: { pID: item.BiometricID },
                query: printQuery,
              }"
              target="_blank"
              title="Print DTR"
            >
              <i class="bi bi-printer"></i>
            </router-link>
          </td>
        </template>
      </CDataTable>
        <!-- <table class="table table-bordered">
          <thead>
            <tr>
              <th scope="col">Personnel ID</th>
              <th scope="col">Last Name</th>
              <th scope="col">First Name</th>
              <th scope="col">Status</th>
              <th scope="col">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item in items"
              :key="item.personnelID"
            >
              <th scope="row">{{ item.personnelID }}</th>
              <td>{{ item.LastName }}</td>
              <td>{{ item.FirstName }}</td>
              <td>Active</td>
              <td><i class="bi bi-eye-fill ml-auto"></i></td>
            </tr>
          </tbody>
        </table> -->
    </CCardBody>
  </CCard>
</template>

<script>
export default {
  name: 'Table',
  props: {
    items: Array,
    fields: {
      type: Array,
      default () {
        return ['BiometricID', 'FirstName', 'LastName', 'status', 'action']
      }
    },
    caption: {
      type: String,
      default: 'Table'
    },
    hover: Boolean,
    striped: Boolean,
    border: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean,
    periodFrom: {
      type: String,
      default: '',
    },
    periodTo: {
      type: String,
      default: '',
    },
  },
  computed: {
    dtrQuery() {
      if (!this.periodFrom || !this.periodTo) {
        return {};
      }
      return {
        from: this.periodFrom,
        to: this.periodTo,
      };
    },
    printQuery() {
      if (!this.periodFrom || !this.periodTo) {
        return { autoprint: '1' };
      }
      return {
        from: this.periodFrom,
        to: this.periodTo,
        autoprint: '1',
      };
    },
  },
  methods: {
    getBadge (status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'secondary'
          : status === 'Pending' ? 'warning'
            : status === 'Banned' ? 'danger' : 'primary'
    }
  }
}
</script>

<style scoped>
.employee-table-card {
  border-radius: 12px;
  overflow: hidden;
}

.employee-table-header {
  background: #fff;
  border-bottom: 1px solid rgba(0, 0, 21, 0.06);
  color: #2b3a55;
  font-weight: 600;
  padding: 0.85rem 1rem;
}

.employee-table-body {
  padding: 0.75rem 1rem 1rem;
}

::v-deep .table-responsive {
  width: 100%;
}

::v-deep table {
  color: #2b3a55;
  width: 100%;
}

::v-deep thead th {
  border-top: none;
  border-bottom: 2px solid rgba(0, 0, 21, 0.06);
  color: #768192;
  font-size: 0.76rem;
  font-weight: 700;
  letter-spacing: 0.35px;
  text-transform: uppercase;
}

::v-deep tbody td,
::v-deep tbody th {
  vertical-align: middle;
  border-color: rgba(0, 0, 21, 0.05);
}

::v-deep tbody tr:hover {
  background: rgba(77, 141, 255, 0.04);
}

::v-deep .badge {
  border-radius: 999px;
  padding: 0.35em 0.7em;
  font-weight: 600;
}

::v-deep .bi-eye-fill,
::v-deep .bi-printer {
  color: #4d8dff;
}
</style>
